'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
    'strong',
    null,
    'For specialty: '
);

var _ref2 = _react2.default.createElement(
    'strong',
    null,
    'For conditions: '
);

var _ref3 = _react2.default.createElement(
    'strong',
    null,
    'For procedures: '
);

var _ref4 = _react2.default.createElement(
    'strong',
    null,
    'Connection: '
);

var PeerRecommendation = function PeerRecommendation(props) {
    var recommendationDate = props.recommendationDate,
        authorName = props.authorName,
        recommendeeName = props.recommendeeName,
        authorProfileImage = props.authorProfileImage,
        authorSpecialtyImage = props.authorSpecialtyImage,
        recommendationText = props.recommendationText,
        specialty = props.specialty,
        conditions = props.conditions,
        procedures = props.procedures,
        connection = props.connection,
        className = props.className,
        profileImageStyle = props.profileImageStyle,
        titleContainerStyle = props.titleContainerStyle,
        titleStyle = props.titleStyle,
        recommendationContentStyle = props.recommendationContentStyle,
        specialistUri = props.specialistUri;

    return _react2.default.createElement(
        'div',
        { className: _style2.default.peerRecommendation + ' ' + className },
        _react2.default.createElement(
            'div',
            { className: _style2.default.reviewContainer },
            _react2.default.createElement(
                'div',
                { className: _style2.default.reviewHeader },
                (authorProfileImage || authorSpecialtyImage) && _react2.default.createElement('img', { src: authorProfileImage ? authorProfileImage : authorSpecialtyImage, className: _style2.default.peerProfileImage + ' ' + profileImageStyle }),
                _react2.default.createElement(
                    'div',
                    { className: _style2.default.titleContainer + ' ' + titleContainerStyle },
                    authorName && _react2.default.createElement(
                        'h3',
                        { className: _style2.default.peerRecommendationAuthor + ' ' + titleStyle
                        },
                        'BY ',
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: 'https://www.doctify.com/uk/specialist/' + specialistUri, target: '_blank' },
                            authorName
                        )
                    ),
                    recommendeeName && recommendeeName.trim() && _react2.default.createElement(
                        'div',
                        { className: _style2.default.recommendeeContainer },
                        'Recommending ',
                        _react2.default.createElement(
                            'span',
                            { className: _style2.default.recommendee },
                            recommendeeName.trim()
                        )
                    ),
                    recommendationDate && _react2.default.createElement(
                        'div',
                        { className: _style2.default.recommendationDate },
                        (0, _moment2.default)(recommendationDate).format('DD-MM-YYYY')
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default.recommendation + ' ' + recommendationContentStyle },
                recommendationText
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default.peerRecommendationBottomSection },
                specialty ? _react2.default.createElement(
                    'div',
                    null,
                    _ref,
                    _react2.default.createElement(
                        'span',
                        null,
                        specialty
                    )
                ) : null,
                conditions ? _react2.default.createElement(
                    'div',
                    null,
                    _ref2,
                    _react2.default.createElement(
                        'span',
                        null,
                        conditions
                    )
                ) : null,
                procedures ? _react2.default.createElement(
                    'div',
                    null,
                    _ref3,
                    _react2.default.createElement(
                        'span',
                        null,
                        procedures
                    )
                ) : null,
                connection ? _react2.default.createElement(
                    'div',
                    null,
                    _ref4,
                    _react2.default.createElement(
                        'span',
                        null,
                        connection
                    )
                ) : null
            )
        )
    );
};

PeerRecommendation.propTypes = {
    recommendationDate: require('react').PropTypes.string,
    authorName: require('react').PropTypes.string,
    recommendeeName: require('react').PropTypes.string,
    authorProfileImage: require('react').PropTypes.string,
    authorSpecialtyImage: require('react').PropTypes.string,
    recommendationText: require('react').PropTypes.string,
    specialty: require('react').PropTypes.string,
    conditions: require('react').PropTypes.string,
    procedures: require('react').PropTypes.string,
    connection: require('react').PropTypes.string,
    className: require('react').PropTypes.string,
    profileImageStyle: require('react').PropTypes.string,
    titleContainerStyle: require('react').PropTypes.string,
    titleStyle: require('react').PropTypes.string,
    recommendationContentStyle: require('react').PropTypes.string,
    specialistUri: require('react').PropTypes.string.isRequired
};
PeerRecommendation.displayName = 'PeerRecommendation';

PeerRecommendation.defaultProps = {
    recommendationDate: '',
    authorName: '',
    authorProfileImage: '',
    recommendationText: '',
    specialty: '',
    conditions: '',
    procedures: '',
    connection: ''
};

exports.default = (0, _reactIntl.injectIntl)(PeerRecommendation);



//////////////////
// WEBPACK FOOTER
// ./node_modules/peer-recommendation/lib/components/peer-recommendations.js
// module id = 2216
// module chunks = 0